import * as React from 'react';

const SvgIcon = (props) => {
  if (props.size === 'sm') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill={props.fill || '#1D252D'} viewBox="0 -960 960 960">
        <path d="M479.23-164q-131.92 0-223.96-92.04T163.62-480h51.23q1.15 108.62 78.27 186.31Q370.23-216 479.23-216t186.5-77.5 77.5-186.5-77.5-186.5-186.5-77.5q-58.54 0-108.39 22.72-49.86 22.71-86.15 62.51h101.62v52H183.23v-203.08h52v130.77q43.69-53.46 106.62-85.19Q404.77-796 479.23-796q65.77 0 123.25 24.87t100.24 67.64q42.77 42.76 67.64 100.24T795.23-480t-24.87 123.25-67.64 100.24q-42.76 42.77-100.24 67.64T479.23-164m108.08-186.92L454.39-483.85V-672h51.99v165.85l118.08 118.07z"></path>
      </svg>
    );
  }
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill={props.fill || '#1D252D'} viewBox="0 -960 960 960">
      <path d="M479.23-140q-129.92 0-226.46-85.54T141.62-440h61.23Q218-336.38 296.12-268.19 374.23-200 479.23-200q117 0 198.5-81.5t81.5-198.5-81.5-198.5-198.5-81.5q-65.54 0-122.84 29.12-57.31 29.11-98.7 80.11h104.62v60H159.23v-203.08h60v94.77q48.69-57.46 116.62-89.19Q403.77-820 479.23-820q70.77 0 132.62 26.77 61.84 26.77 107.84 72.77t72.77 107.85q26.77 61.84 26.77 132.61t-26.77 132.61q-26.77 61.85-72.77 107.85t-107.84 72.77Q550-140 479.23-140m120.08-178.92L450.39-467.85V-680h59.99v187.85l131.08 131.07z"></path>
    </svg>
  );
};

export default SvgIcon;
